<template>

    <div id="tenants">

        <div class="flex">
            <div class="flex-1 mb-4">
                <h1 class="text-2xl font-medium text-gray-900 capitalize">Create Tenant</h1>
            </div>

            <div class="flex mb-4 justify-end"></div>
        </div>

        <div class="flex flex-col"  v-if="loaded">

            <form action="#" method="POST" @submit.prevent="form.createTenant()">

                <div class="panel">

                    <div class="panel-form">
                        <div class="panel-title">
                            <h3>Tenant</h3>
                            <p>
                                Setup a new Tenant.
                            </p>
                        </div>
                        <div class="panel-section">
                            <div class="grid grid-cols-6 gap-6">

                                <div class="form-control col-span-6 xl:col-span-4" :class="{ 'form-control-error': form.fieldHasErrors('name') }">
                                    <label for="tenant_name" class="block text-sm font-medium text-gray-700">Tenant Name<i></i></label>
                                    <input type="text" name="name" id="tenant_name" v-model="form.data.name">
                                    <span v-if="form.fieldHasErrors('name')">{{ form.getFieldError('name') }}</span>
                                </div>

                                <div class="form-control col-span-6 xl:col-span-4" :class="{ 'form-control-error': form.fieldHasErrors('prefix') }">
                                    <label for="tenant_name" class="block text-sm font-medium text-gray-700">Prefix<i></i></label>
                                    <input type="text" name="prefix" id="tenant_prefix" v-model="form.data.prefix">
                                    <span v-if="form.fieldHasErrors('prefix')">{{ form.getFieldError('prefix') }}</span>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>

                <div class="flex mt-6 justify-end">

                    <div class="flex border-l-4 border-brand-500 bg-white text-gray-700 px-4 py-1 rounded tracking-wide shadow items-center text-brand-400" v-if="form.successful()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                        <p class="text-gray-700 text-sm" v-html="form.getSuccessMessage()"></p>
                    </div>

                    <div class="flex border-l-4 border-error-500 bg-error-50 text-gray-700 px-4 py-1 rounded tracking-wide shadow items-center text-error-400" v-if="form.hasError()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                        <p class="text-error-500 text-sm" v-html="form.getErrorMessage()"></p>
                    </div>

                    <button type="submit" class="btn-outline justify-center px-6 ml-6" @click.prevent="goBack">
                        Go Back
                    </button>

                    <button type="submit" class="btn justify-center px-6 ml-6" :disabled="form.isFormUpdating()">
                        <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" v-if="form.isFormUpdating()">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Create Tenant
                    </button>
                </div>
            </form>

        </div>
        <Loading message="Loading Tenants" v-else></Loading>

    </div>

</template>

<script>
import Loading from "../Support/Loading";
import {Tenant} from "../../app/Tenant/Tenant";
import {NavigationMixin} from "../../support/mixins";

export default {
    name: "Tenants",
    mixins: [NavigationMixin],
    data() {
        return {
            form: null,
            loaded: false,
        }
    },
    components: {
        Loading
    },
    mounted() {
        let vm = this;

        new Promise(resolve => {
            vm.form = new Tenant();

            resolve(true);
        }).then(result => {
            vm.loaded = result;
        });
    }
}
</script>


